export default "__VITE_ASSET__$dc8PIks__"